var $f1316b1074463583$exports = {};
$f1316b1074463583$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "\u672A\u9009\u62E9 ".concat(args.item, "\u3002");
  },
  "longPressToSelect": "\u957F\u6309\u4EE5\u8FDB\u5165\u9009\u62E9\u6A21\u5F0F\u3002",
  "select": "\u9009\u62E9",
  "selectedAll": "\u5DF2\u9009\u62E9\u6240\u6709\u9879\u76EE\u3002",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "\u672A\u9009\u62E9\u9879\u76EE",
      one: function one() {
        return "\u5DF2\u9009\u62E9 ".concat(formatter.number(args.count), " \u4E2A\u9879\u76EE");
      },
      other: function other() {
        return "\u5DF2\u9009\u62E9 ".concat(formatter.number(args.count), " \u4E2A\u9879\u76EE");
      }
    }), "\u3002");
  },
  "selectedItem": function selectedItem(args) {
    return "\u5DF2\u9009\u62E9 ".concat(args.item, "\u3002");
  }
};
export { $f1316b1074463583$exports as default };